<template>
  <div v-if="longitude && longitude">
    <div v-html="getMapUrl()" />
    <!-- <div class="font-size-14">{{ description }}</div> -->
    <div class="font-12 text-white bg-blue500 location-footer d-flex align-items-center py-2">
      <IconV2
        class="ms-2 me-1"
        name="v2-location"
        color="white" />
      <span>Vị trí của tôi</span>
    </div>
  </div>
</template>

<script>
import IconV2 from "../common/IconV2";
export default {
  name: "ChatLocation",
  props: ["description", "latitude", "longitude"],
  components: {
    IconV2,
  },
  methods: {
    getMapUrl() {
      let path =
        "<iframe\n" +
        '        width="280"\n' +
        '        height="157"\n' +
        '        style="border-radius: 5px 5px 0 0"\n' +
        '        loading="lazy"\n' +
        "        allowFullScreen\n" +
        '        referrerPolicy="no-referrer-when-downgrade"\n' +
        '        src="https://www.google.com/maps/embed/v1/place?key=AIzaSyDEwUImNs161Hftoim5saIqLLbcYo4V69c\n' +
        "    &q=" +
        Number(this.latitude).toFixed(6) +
        "," +
        Number(this.longitude).toFixed(7) +
        '"\n' +
        "      >\n" +
        "      </iframe>";
      return path;
    },
  },
};
</script>

<style lang="scss" scoped>
.location-footer {
  margin-top: -0.25rem;
  border-radius: 0 0 5px 5px;
}
</style>